import type { AiBusinessCenterModule } from '../types'

/** 项目智能（PJM）— 与 system_module.name=pjm / adminCard 对齐 */
export const pjmModule: AiBusinessCenterModule = {
  key: 'pjm',
  label: '项目智能',
  desc: '人物/智能体资产、需求采集与基线、任务拆分与编排、交付评审、知识沉淀与运营驾驶舱',
  path: '/pjm',
  homePath: '/pjm/work/home',
  icon: 'ep:cpu',
  color: '#0ea5e9',
  aliases: ['PJM', '项目智能', '项目智能管理']
}
